import { toast } from "react-toastify";
import { poster, fetcher, patcher, deleter } from "../../utils/axios.js";
import { addProject, setProjects, removeProject, updateProject, updateStatus, removeProjectSubtheme, restoreProject, setProjectLoading, updatePhaseName, updateLoopName, removeLastLoop, updateLoopLength, updateLoopData } from "../../store/slices/projectsSlice.js";
import { setReferenceDesign } from "../../store/slices/designSlice.js";
import { OpenFileInTab } from "../Attachments/AttachmentActions.js";

export const createNewProject = (projectData, dispatch, closeDialog) => {
    poster("/projects/", projectData).then((response) => {
        if (response?.status === 201) {
            toast.success("Project aangemaakt");
            dispatch(addProject(response.data));
            closeDialog();
        }
    });
};

export const fetchProjects = (dispatch) => {
    fetcher("/projects/").then((response) => {
        if (response?.status === 200) {
            dispatch(setProjects(response.data.sort((a, b) => a.id - b.id)));
        }
    });
};

export const deleteProject = (id, dispatch) => {
    deleter(`/projects/${id}/`).then((response) => {
        if (response.status === 204) {
            dispatch(removeProject(id));
        }
    });
};

export const unDeleteProject = (id, dispatch) => {
    poster(`/projects/${id}/undelete/`).then((response) => {
        if (response.status === 200) {
            dispatch(restoreProject(id));
        }
    })
}

export const selectProject = (id, dispatch) => {
    dispatch(setProjectLoading(true));
    fetcher(`/projects/${id}/`).then((response) => {
        dispatch(updateProject(response.data));
        if (response.data.reference_design) {
            dispatch(setReferenceDesign(response.data.reference_design));
        }
        dispatch(setProjectLoading(false));
    });
};
export const patchProject = (data, dispatch) => {
    patcher(`/projects/${data.id}/`, data).then((response) => {
        if (response.status === 200) {
            dispatch(updateProject(response.data));
        }
    });
};

export const advancePhase = (id, phase, phase_name, dispatch) => {
    console.log(phase, phase_name);
    const data = {
        phase: phase,
        phase_name: phase_name,
    };

    poster(`/projects/${id}/advance_phase/`, data).then((response) => {
        if (response.status === 200) {
            dispatch(updateProject(response.data));
            toast.success("Projectfase aangepast");
        }
    });
};

export const advanceStatus = (id, data, dispatch) => {
    poster(`/projects/${id}/advance_status/`, data).then((response) => {
        if (response.status === 200) {
            console.log(response.data);
            dispatch(updateStatus(response.data));
        }
    });
};

export const addLoopToPhaseWithDesigns = (id, data, dispatch) => {
    poster(`/projects/${id}/add_loop_to_phase/`, data).then((response) => {
        if (response.status === 200) {
            dispatch(updateProject(response.data));
        }
    });
};

export const addLoopToPhase = (id, dispatch) => {
    poster(`/projects/${id}/add_loop_to_phase/`).then((response) => {
        if (response.status === 200) {
            dispatch(updateProject(response.data));
        }
    });
};

export const createOrUpdateProjectThemes = (data, dispatch) => {
    poster("/projectthemes/", data).then((response) => {
        if (response?.status === 201) {
            toast.success("Projectthema's gewijzigd");
            dispatch(updateProject(response.data));
        }
    });
};

export const createOrUpdateProjectSubThemes = (data, dispatch) => {
    poster("/projectsubthemes/", data).then((response) => {
        if (response?.status === 201) {
            toast.success("Aspecten gewijzigd");
            dispatch(updateProject(response.data));
        }
    });
};

export const deleteProjectSubTheme = (subthemeID, projectThemeID, dispatch) => {
    deleter(`/projectsubthemes/${subthemeID}/`).then((response) => {
        if (response.status === 204) {
            dispatch(removeProjectSubtheme(subthemeID, projectThemeID))
        }
    });
};

export const createOrUpdateProjectGoals = (data, dispatch) => {
    poster("/projectgoals/", data).then((response) => {
        if (response?.status === 201) {
            toast.success("Doelen gewijzigd");
            dispatch(updateProject(response.data));
        }
    });
};

export const patchProjectAdvice = (advice, project, { phaseID, loopID, loopThemeId }, dispatch) => {
    patcher(`/advices/${advice.id}/`, advice).then((response) => {
        if (response.status === 200) {
            const updated = response.data;
            // Find the loop that needs to be updated
            let updatedLoop = project.phases.find((phase) => phase.id === phaseID).loops.find((loop) => loop.id === loopID);
            const updatedAdviceByThemes = {
                ...updatedLoop.advice_by_themes,
                [loopThemeId]: updated,
            };
            updatedLoop = { ...updatedLoop, advice_by_themes: updatedAdviceByThemes };

            // Perform the project state update
            dispatch(
                updateProject({
                    ...project,
                    phases: project.phases.map((phase) => {
                        if (phase.id === phaseID) {
                            return {
                                ...phase,
                                loops: phase.loops.map((loop) => (loop.id === loopID ? updatedLoop : loop)),
                            };
                        }
                        return phase;
                    }),
                })
            );
        }
    });
};

// Legacy PDF export (kept for backward compatibility)
export const downloadProjectExportPDF = (project) => {
    toast.success("Export wordt gedownload. Dit kan even duren.", { autoClose: 1000 });
    fetcher(`/projects/${project.id}/export_to_pdf/`, "blob").then((response) => {
        if (response.status === 200) {
            toast.success("Export klaar!", { autoClose: 1000 });
            const blob = new Blob([response.data], { type: response.headers["content-type"], name: project.name + ".pdf" });
            const blobURL = URL.createObjectURL(blob);
            OpenFileInTab(blobURL);
        } else {
            toast.error("Er is iets misgegaan bij het downloaden van de export.");
        }
    });
};

// New DOCX export - handled by ExportDialog component
// This function is just a placeholder for consistency
// The actual export is triggered by opening the ExportDialog
export const downloadProjectExport = downloadProjectExportPDF; // Default to PDF for now

export const renamePhase = async (projectId, phaseId, newName, dispatch) => {
    // Since there's no direct phase endpoint, we'll need to create a custom endpoint
    // For now, let's create a custom project action
    const data = { phase_id: phaseId, phase_name: newName };
    
    try {
        const response = await poster(`/projects/${projectId}/rename_phase/`, data);
        if (response?.status === 200) {
            toast.success("Fase hernoemd");
            // Update the project in Redux store
            dispatch(updatePhaseName({id: phaseId, newName: newName}));
            return response.data;
        } else {
            toast.error("Er is een fout opgetreden bij het hernoemen van de fase");
        }
    } catch (error) {
        toast.error("Er is een fout opgetreden bij het hernoemen van de fase");
        console.error("Phase rename error:", error);
    }
};

export const renameLoop = async (projectId, loopId, newName, dispatch) => {
    // For loops, we can potentially use the enhancedloops endpoint if it supports loop_name
    // But since DesignLoop doesn't have a loop_name field, we'll need a custom solution too
    const data = { loop_id: loopId, loop_name: newName };
    
    try {
        const response = await poster(`/projects/${projectId}/rename_loop/`, data);
        if (response?.status === 200) {
            toast.success("Ontwerploop hernoemd");
            // Update the project in Redux store
            dispatch(updateLoopName({id: loopId, newName: newName}));
            return response.data;
        } else {
            toast.error("Er is een fout opgetreden bij het hernoemen van de ontwerploop");
        }
    } catch (error) {
        toast.error("Er is een fout opgetreden bij het hernoemen van de ontwerploop");
        console.error("Loop rename error:", error);
    }
};

export const updateLoopLengthAction = async (projectId, loopId, length, dispatch) => {
    const data = { loop_id: loopId, length: length };
    try {
        const response = await poster(`/projects/${projectId}/update_loop_data/`, data);
        if (response?.status === 200) {
            dispatch(updateLoopLength({id: loopId, length: length}));
            return response.data;
        } 
    } catch (error) {
        toast.error("Er is een fout opgetreden bij het updaten van de lengte van de ontwerploop");
        console.error("Update loop length error:", error);
    }
};

export const updateLoopDataAction = async (projectId, loopId, data, dispatch) => {
    data = {
        loop_id: loopId,
        ...data
    }
    try {
        const response = await poster(`/projects/${projectId}/update_loop_data/`, data);
        if (response?.status === 200) {
            dispatch(updateLoopData({id: loopId, ...data}));
            return response.data;
        } 
    } catch (error) {
        toast.error("Er is een fout opgetreden bij het updaten van de commentaar van de ontwerploop");
        console.error("Update loop length error:", error);
    }
};

export const deleteLastLoop = async (projectId, dispatch) => {
    try {
        const response = await deleter(`/projects/${projectId}/delete_last_loop/`);
        if (response?.status === 204) {
            toast.success("Laatste ontwerploop verwijderd");
            // Refresh the project data by fetching it again
            dispatch(removeLastLoop());
            return true;
        } else {
            toast.error("Er is een fout opgetreden bij het verwijderen van de ontwerploop");
            return false;
        }
    } catch (error) {
        toast.error("Er is een fout opgetreden bij het verwijderen van de ontwerploop");
        console.error("Delete loop error:", error);
        return false;
    }
};


